import ArtistsFilterComponent from './ArtistsFilter.component'

export default ArtistsFilterComponent